<div style="display: flex; justify-content: space-between; flex-direction: row;">
  <h2 mat-dialog-title><strong> Incapacidades </strong></h2>
  <div
    style="width: 30px; height: 30px; border-radius: 50%; display: flex; justify-content: center; align-items: center; cursor:pointer"
    class="mat-elevation-z3" (click)="dialogRef.close()"><i class="fa fa-times "></i></div>
</div>

<mat-dialog-content class="mat-typography">
  <div *ngIf="tipoRedireccion=='nuevo'">

    <mat-horizontal-stepper linear="true">
      <mat-step [stepControl]="firtsForm">
        <ng-template matStepLabel>Seleccion</ng-template>

        <form [formGroup]="firtsForm">

          <div class="mat-elevation-z3" style="display: flex; justify-content: space-between; margin-bottom: 15px;">
            <h3 style="margin: 10px;"><strong>{{nombreSelecionado}}</strong></h3>
            <button style="background-color: #343a40; color:white;" class="mat-elevation-z2" mat-button
              matStepperNext><i class="fa fa-arrow-right"></i></button>
          </div>

          <div style="display: none">
            <mat-form-field>
              <input autocomplete="off" type="text" formControlName='selection' matInput required>
            </mat-form-field>
          </div>

          <data-table [columns]='columnasUsuarios' [configuration]='configurationUsuarios'
            (selection)='seleccionadosUsuarios($event)' (clickRow)='clickFilaUsuarios($event)'
            [params]="[{ id:'state', value: 1  }]" [url]='urlGetUsuarios'>
          </data-table>

        </form>

      </mat-step>

      <mat-step [stepControl]="FormDisabilities">
        <ng-template matStepLabel>Informacion</ng-template>
        <form [formGroup]="FormDisabilities"
          (ngSubmit)="FormDisabilities.valid?saveForm(FormDisabilities.value):errorMessage()">

          <div class="mat-elevation-z3" style="display: flex; justify-content: space-between; margin-bottom: 5px;">
            <button style="background-color: #343a40; color:white;" class="mat-elevation-z2" mat-button
              matStepperPrevious><i class="fa fa-arrow-left"></i></button>
            <h3 style="margin: 10px;"><strong>{{nombreSelecionado}}</strong></h3>
            <h3 style="margin: 10px" *ngIf="usuario"><strong>Usuario: {{usuario}}</strong> </h3>
            <button style="background-color: #343a40; color:white;" class="mat-elevation-z2" mat-button matStepperNext
              type="submit"><i class="fa fa-arrow-right"></i></button>
          </div>

          <div style='display: flex; width: 100%; '>
            <div style='flex:12'>
              <cdk-virtual-scroll-viewport itemSize="100" class="example-viewport">
                <div class='first-row'>

                  <div class='row-item'>
                    <mat-form-field>
                      <mat-label>Fecha</mat-label>
                      <input matInput [matDatepicker]="fechaIncapacidad" autocomplete="off" matInput
                        formControlName='date' required>
                      <mat-datepicker-toggle matSuffix [for]="fechaIncapacidad">
                      </mat-datepicker-toggle>
                      <mat-datepicker #fechaIncapacidad [touchUi]='movil?true:false'></mat-datepicker>
                      <mat-error>Campo requerido</mat-error>
                    </mat-form-field>
                  </div>

                  <div class='row-item'>
                    <mat-form-field>
                      <mat-label>Fecha inicio</mat-label>
                      <input matInput [matDatepicker]="fechaInicio" autocomplete="off" matInput
                        formControlName='startDate' (dateChange)="changeDate($event, 'inicio')" required>
                      <mat-datepicker-toggle matSuffix [for]="fechaInicio">
                      </mat-datepicker-toggle>
                      <mat-datepicker #fechaInicio [touchUi]='movil?true:false'></mat-datepicker>
                      <mat-error>Campo requerido</mat-error>
                    </mat-form-field>
                  </div>

                  <div class='row-item'>
                    <mat-form-field>
                      <mat-label>Fecha Final</mat-label>
                      <input matInput [matDatepicker]="fechaFinal" autocomplete="off" matInput
                        formControlName='finalDate' (dateChange)="changeDate($event, 'final')" required>
                      <mat-datepicker-toggle matSuffix [for]="fechaFinal">
                      </mat-datepicker-toggle>
                      <mat-datepicker #fechaFinal [touchUi]='movil?true:false'></mat-datepicker>
                      <mat-error>Campo requerido</mat-error>
                    </mat-form-field>
                  </div>

                </div>

                <div class='default-row'>

                  <div class='row-item'>
                    <mat-form-field>
                      <input [readonly]='duration==null' autocomplete="off" type="text" formControlName='duration'
                        matInput placeholder="Duración" required>
                    </mat-form-field>
                  </div>

                  <div class='row-item'>
                    <!-- Eps -->
                    <combos [configuration]='combosConfigEps' [reloadCombo]='reloadComboEps' [required]="true"
                      [disabled]="true" 
                      [control]="FormDisabilities.get('eps')" >
                    </combos>
                  </div>

                  <div class='row-item'>
                    <!-- Arl -->
                    <combos [configuration]='combosConfigArl' [reloadCombo]='reloadComboArl' [required]="true"
                      [filter]="true" [disabled]="true" 
                      [control]="FormDisabilities.get('arl')" >
                    </combos>
                  </div>

                </div>

                <div class='default-row'>

                  <div class='row-item'>
                    <file-input [params]='fileInputIncapacidad' (fileSave)='fileSaveIncapacidad($event)'></file-input>
                  </div>

                  <div class='row-item'>
                    <mat-form-field>
                      <input autocomplete="off" type="text" formControlName='description' matInput #descripcion
                        maxlength="1024" placeholder="Descripción" required>
                      <mat-hint>{{descripcion.value.length}}/1024</mat-hint>
                      <mat-error>Campo requerido</mat-error>
                    </mat-form-field>
                  </div>

                  <div class='row-item'>
                    <mat-form-field>
                      <input autocomplete="off" type="text" formControlName='disabilityType' matInput #descripcion
                        maxlength="1024" placeholder="Tipo incapacidad" required>
                      <mat-hint>{{descripcion.value.length}}/1024</mat-hint>
                      <mat-error>Campo requerido</mat-error>
                    </mat-form-field>
                  </div>

                </div>

              </cdk-virtual-scroll-viewport>
            </div>
          </div>

        </form>
      </mat-step>

      <mat-step>

        <ng-template matStepLabel>Finalizar</ng-template>
        <div class="mat-elevation-z2" style="display: flex; justify-content: space-between; margin-bottom: 30px;">
          <button style="background-color: #343a40; color:white;" class="mat-elevation-z2" mat-button
            matStepperPrevious><i class="fa fa-arrow-left"></i></button>
          <button class="mat-elevation-z2" mat-mini-fab color="warn" (click)="save()">
            <mat-icon>save</mat-icon>
          </button>
        </div>

        <div style="width: 100%; display: flex; flex-direction: row;">
          <ng-container *ngTemplateOutlet="SummaryInformation"></ng-container>
        </div>
      </mat-step>

    </mat-horizontal-stepper>

  </div>


  <div *ngIf="tipoRedireccion=='visualizar'" style="width: 100%; display: flex; flex-direction: row;">
    <ng-container *ngTemplateOutlet="SummaryInformation"></ng-container>
  </div>
</mat-dialog-content>

<ng-template #SummaryInformation>

  <div style="width: 50%; height: 100%; display: flex; flex-direction: column; text-align: center; align-self: center;">
    <div>
      <img src="{{imageSrc}}" [ngStyle]="sizePicture">
      <h3 style="margin-top: 15px;"><strong>Nombre: </strong> {{nombreSelecionado}}</h3>
      <h3><strong>Usuario: </strong> {{usuario}}</h3>
    </div>
  </div>

  <div style="text-align: center; width: 50%; height: 100%;">
    <mat-tab-group mat-stretch-tabs class="example-stretched-tabs mat-elevation-z1">
      <mat-tab label="">
        <mat-list>

          <mat-list-item><strong>Fecha</strong>: {{fechaLabel}} </mat-list-item>
          <mat-divider></mat-divider>
          <mat-list-item><strong>Fecha Inicio</strong>: {{inicio}} </mat-list-item>
          <mat-divider></mat-divider>
          <mat-list-item><strong>Fecha Fin</strong>: {{final}} </mat-list-item>
          <mat-divider></mat-divider>
          <mat-list-item><strong>Duracion</strong>: {{duration}} </mat-list-item>
          <mat-divider></mat-divider>
          <mat-list-item><strong>ARL</strong>: {{arlLabel}}</mat-list-item>
          <mat-divider></mat-divider>
          <mat-list-item><strong>EPS</strong>: {{epsLabel}}</mat-list-item>
          <mat-divider></mat-divider>
          <mat-list-item><strong>Tipo Incapacidad</strong>: {{disabilityTypeLabel}} </mat-list-item>
          <mat-divider></mat-divider>
          <mat-list-item *ngIf="tipoRedireccion=='nuevo'"><strong>Anexo</strong>: {{nameFile}} </mat-list-item>
          <mat-divider></mat-divider>
          <mat-list-item *ngIf="tipoRedireccion=='visualizar'"><strong>Anexo: </strong>
          <mat-icon style="margin-left: 7px;" (click)="openAnexo()">picture_as_pdf</mat-icon>
          </mat-list-item><mat-divider></mat-divider>
          <mat-list-item><strong>Descripcion</strong>: {{descripcionLabel}} </mat-list-item>
          <mat-divider></mat-divider>
        </mat-list>
      </mat-tab>
    </mat-tab-group>
  </div>
</ng-template>